module.exports = __webpack_public_path__ + "static/img/banner5.732d62d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/banner5.jpg
// module id = V85c
// module chunks = 0